export enum EPagination {
	MIN = 15,
	MIDDLE = 50,
	MAX = 100,
}

export enum EPaginationParams {
	OFFSET = 'offset',
	LIMIT = 'limit',
	PAGE = 'page',
}
